import { render, staticRenderFns } from "./columnDynamicData.vue?vue&type=template&id=632d9ec8&scoped=true"
import script from "./columnDynamicData.vue?vue&type=script&lang=js"
export * from "./columnDynamicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d9ec8",
  null
  
)

export default component.exports